// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BroadcastEventController from "./broadcast_event_controller"
application.register("broadcast-event", BroadcastEventController)

import BlogTocController from "./blog_toc_controller"
application.register("blog-toc", BlogTocController)

import BillingCheckoutRefreshController from "./billing_checkout_refresh_controller"
application.register("billing-checkout-refresh", BillingCheckoutRefreshController)

import AttendanceMembershipController from "./attendance_membership_controller"
application.register("attendance-membership", AttendanceMembershipController)

import CalendarTailwindController from "./calendar_tailwind_controller"
application.register("calendar-tailwind", CalendarTailwindController)

import SessionTemplatePreviewController from "./session_template_preview_controller"
application.register("session-template-preview", SessionTemplatePreviewController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import SupportChatController from "./support_chat_controller"
application.register("support-chat", SupportChatController)

import DateNavigationController from "./date_navigation_controller"
application.register("date-navigation", DateNavigationController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import FieldToggleController from "./field_toggle_controller"
application.register("field-toggle", FieldToggleController)

import InteractionPreviewController from "./interaction_preview_controller"
application.register("interaction-preview", InteractionPreviewController)

import LeadPrefillController from "./lead_prefill_controller"
application.register("lead-prefill", LeadPrefillController)

import MaskedApiKeyController from "./masked_api_key_controller"
application.register("masked-api-key", MaskedApiKeyController)

import MaxAttendeesToggleController from "./max_attendees_toggle_controller"
application.register("max-attendees-toggle", MaxAttendeesToggleController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MoonshotSideNavController from "./moonshot/side_nav_controller"
application.register("moonshot--side-nav", MoonshotSideNavController)

import MoonshotTopNavController from "./moonshot/top_nav_controller"
application.register("moonshot--top-nav", MoonshotTopNavController)

import MoonshotDropdownController from "./moonshot/dropdown_controller"
application.register("moonshot--dropdown", MoonshotDropdownController)

import MoonshotPopoverController from "./moonshot/popover_controller"
application.register("moonshot--popover", MoonshotPopoverController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import PostHogController from "./post_hog_controller"
application.register("post-hog", PostHogController)

import ReportChartController from "./report_chart_controller"
application.register("report-chart", ReportChartController)

import RemoverController from "./remover_controller"
application.register("remover", RemoverController)

import RecurrenceFieldsController from "./recurrence_fields_controller"
application.register("recurrence-fields", RecurrenceFieldsController)

import SeoLeadCaptureController from "./seo_lead_capture_controller"
application.register("seo-lead-capture", SeoLeadCaptureController)

import SpinnerButtonController from "./spinner_button_controller"
application.register("spinner-button", SpinnerButtonController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import VisitController from "./visit_controller"
application.register("visit", VisitController)
